import { render, staticRenderFns } from "./comments-external-player-controls.vue?vue&type=template&id=27eca536&scoped=true&"
import script from "./comments-external-player-controls.vue?vue&type=script&lang=js&"
export * from "./comments-external-player-controls.vue?vue&type=script&lang=js&"
import style0 from "./comments-external-player-controls.vue?vue&type=style&index=0&id=27eca536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eca536",
  null
  
)

export default component.exports